import React, { useState } from "react";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import DashboardCustomizeRoundedIcon from "@mui/icons-material/DashboardCustomizeRounded";
import Diversity3RoundedIcon from "@mui/icons-material/Diversity3Rounded";
import ForestRoundedIcon from "@mui/icons-material/ForestRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import LibraryBooksRoundedIcon from "@mui/icons-material/LibraryBooksRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import MarkUnreadChatAltRoundedIcon from "@mui/icons-material/MarkUnreadChatAltRounded";
import PsychologyRoundedIcon from "@mui/icons-material/PsychologyRounded";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { apiUrl } from "./apiBase";
import "./App.css";
import "./Home.css";
import LegalFooter from "./components/LegalFooter";

const audienceCards = [
  {
    title: "Öğretmenler için",
    desc: "Yoklama, ödev, gözlem ve gelişim notları tek akışta tutulur; veliye gönderilecek mesaj hazır hâle gelir.",
    icon: <SchoolRoundedIcon />
  },
  {
    title: "Sınıf yönetimi için",
    desc: "Sınıftaki öğrencilerin gelişim kayıtları karşılaştırmadan, yarıştırmadan ve veli erişimi güvenli kalacak şekilde izlenir.",
    icon: <DashboardCustomizeRoundedIcon />
  },
  {
    title: "Veliler için",
    desc: "WhatsApp üzerinden soru sorar, kayıt paylaşır, öğrenci360 bağlantısıyla gelişimi anlık takip eder.",
    icon: <Diversity3RoundedIcon />
  }
];

const modules = [
  {
    title: "WhatsApp Asistanı",
    desc: "Veli sorularını doğal dille karşılar; ödev, yoklama, sınav, ödeme ve haftalık özetleri hızlıca yanıtlar.",
    icon: <WhatsAppIcon />
  },
  {
    title: "Öğrenci360",
    desc: "Devamsızlık, ödev, sınav, okuma, çalışma ve gözlem verilerini tek öğrenci görünümünde birleştirir.",
    icon: <InsightsRoundedIcon />
  },
  {
    title: "Sınav ve Değerlendirme Takibi",
    desc: "Genel değerlendirme, hikâye kitabı değerlendirmesi ve deneme sonuçları çocuğa özel gelişim raporuna bağlanır.",
    icon: <QueryStatsRoundedIcon />
  },
  {
    title: "Öğretmen Gözlem Günlüğü",
    desc: "Akademik ve davranışsal gözlemler yapılandırılır; hazır olduğunda velilere WhatsApp ile gönderilir.",
    icon: <AssignmentTurnedInRoundedIcon />
  },
  {
    title: "Yapay Zekâ Destekli Rehberlik",
    desc: "Veli sorularını, öğretmen notlarını ve gelişim kayıtlarını anlamlandırarak kısa, anlaşılır ve bağlama uygun özetler üretir.",
    icon: <PsychologyRoundedIcon />
  },
  {
    title: "Değerler ve Maarif Uyumlu Rehberlik",
    desc: "Değer çalışmaları, aile formları ve öğrenme çıktıları süreç boyunca takip edilir.",
    icon: <AutoAwesomeRoundedIcon />
  },
  {
    title: "Okuma, Kütüphane ve Çalışma Takibi",
    desc: "Sayfa, kitap ve ders bazlı soru kayıtları hem WhatsApp hem panel üzerinden gelişim raporuna dönüşür.",
    icon: <LibraryBooksRoundedIcon />
  },
  {
    title: "Yıldız Bahçem ve Gelecek Ormanı",
    desc: "Pozitif davranış, sorumluluk ve sürdürülebilir alışkanlıklar oyunlaştırılmış modüllerle desteklenir.",
    icon: <ForestRoundedIcon />
  }
];

const messageExamples = [
  {
    from: "Veli",
    text: "Bugünkü ödevler ne?",
    reply: "Yusuf için bugün Matematik ve Türkçe ödevleri listelendi. İsterseniz ders detayını sorabilirsiniz."
  },
  {
    from: "Öğretmen",
    text: "Gözlem kaydını veliye gönder",
    reply: "Gözlem notu hazırlandı ve WhatsApp üzerinden veliye gönderim durumu takip edildi."
  },
  {
    from: "Veli",
    text: "Son deneme sonucu nasıl?",
    reply: "Deneme sonucu, ders kırılımları ve önceki değerlendirmelere göre gelişim özeti güvenli bağlantıyla paylaşılır."
  },
  {
    from: "Veli",
    text: "öğrenci360",
    reply: "Tek kullanımlık güvenli bağlantı ile öğrencinin güncel gelişim ekranı açılır."
  }
];

const workflow = [
  {
    title: "Sınıf ve veli bağlantısı kurulur",
    desc: "Öğrenciler, veliler ve öğretmen akışı güvenli şekilde tanımlanır; her veli yalnızca kendi çocuğunu görür."
  },
  {
    title: "Öğretmen günlük akışı işler",
    desc: "Yoklama, ödev, gözlem, okuma ve değerlendirme kayıtları sınıf bazlı panelden girilir."
  },
  {
    title: "Veli WhatsApp’tan iletişim kurar",
    desc: "Soru sorar, çalışma veya okuma kaydı paylaşır, güncel bilgilere beklemeden ulaşır."
  },
  {
    title: "Çocuğa özel gelişim raporu oluşur",
    desc: "Öğrenci360, özetler ve raporlar çocuğu başkalarıyla yarıştırmadan kendi gelişim yolculuğunu görünür kılar."
  }
];

const trustItems = [
  "Veli yalnızca kendi çocuğunu görür",
  "WhatsApp Cloud API uyumlu akış",
  "Öğretmen ve veli bazlı güvenli erişim",
  "Magic link ile güvenli veli erişimi"
];

function Home() {
  const [isDemoOpen, setIsDemoOpen] = useState(false);

  const openDemo = () => setIsDemoOpen(true);
  const closeDemo = () => setIsDemoOpen(false);

  return (
    <div className="dandu-home">
      <DanduHeader onOpenDemo={openDemo} />

      <main>
        <section className="dandu-hero">
          <div className="dandu-container dandu-hero-grid">
            <div className="dandu-hero-copy">
              <p className="dandu-kicker">DANDU</p>
              <h1>Öğretmen-veli iletişimini WhatsApp’tan gelişim takibine bağlayın.</h1>
              <p className="dandu-lead">
                DANDU; öğretmenin günlük gözlem, ödev, sınav, okuma ve gelişim
                kayıtlarını velinin anlık WhatsApp iletişimiyle buluşturan;
                her çocuk için karşılaştırmadan ve yarıştırmadan gelişim hafızası
                oluşturan yapay zekâ destekli dijital rehberlik platformudur.
              </p>
              <div className="dandu-proof" aria-label="Platform öne çıkanları">
                <span>WhatsApp ile anlık iletişim</span>
                <span>Öğrenci360 gelişim ekranı</span>
                <span>Sınav ve değerlendirme takibi</span>
                <span>Yapay zekâ destekli özetler</span>
              </div>
            </div>

            <div className="dandu-hero-panel" aria-label="DANDU WhatsApp ve gelişim örneği">
              <div className="dandu-phone-card">
                <div className="dandu-phone-header">
                  <span className="dandu-whatsapp-mark" aria-hidden="true"><WhatsAppIcon /></span>
                  <div>
                    <strong>DANDU WhatsApp Asistanı</strong>
                    <small>Veli iletişimi ve kayıt toplama</small>
                  </div>
                </div>
                <div className="dandu-chat-list">
                  <div className="dandu-chat-bubble dandu-chat-parent">Bugünkü ödevler ne?</div>
                  <div className="dandu-chat-bubble dandu-chat-dandu">Matematik ve Türkçe ödevleri hazır. Öğrenci360 bağlantısını da paylaşabilirim.</div>
                  <div className="dandu-chat-bubble dandu-chat-parent">Bugün 35 sayfa okudu.</div>
                  <div className="dandu-chat-bubble dandu-chat-dandu">Kaydedildi. Bu haftaki okuma toplamı güncellendi.</div>
                </div>
              </div>

              <div className="dandu-dashboard-card">
                <div className="dandu-dashboard-topline">
                  <span>Öğrenci360</span>
                  <strong>Canlı gelişim özeti</strong>
                </div>
                <div className="dandu-mini-metrics">
                  <MiniMetric label="Deneme" value="84 net" />
                  <MiniMetric label="Okuma" value="128 sf." />
                  <MiniMetric label="Çalışma" value="480 dk" />
                </div>
                <div className="dandu-progress-row">
                  <span>Veli katılımı</span>
                  <div><i style={{ width: "78%" }} /></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="kim-icin" className="dandu-section dandu-section-compact">
          <div className="dandu-container">
            <div className="dandu-audience-grid">
              {audienceCards.map((card) => (
                <AudienceCard key={card.title} {...card} />
              ))}
            </div>
          </div>
        </section>

        <section id="iletisim" className="dandu-section">
          <div className="dandu-container dandu-split dandu-split-wide">
            <div className="dandu-section-heading">
              <p className="dandu-eyebrow">WhatsApp Öncelikli Deneyim</p>
              <h2>Velinin zaten kullandığı kanaldan hızlı ve kayıtlı iletişim.</h2>
              <p>
                DANDU, öğretmen-veli iletişimini ayrı bir uygulama indirmeye
                zorlamadan WhatsApp üzerinden yürütür. Veli soru sorar, kayıt
                girer, sınav sonucunu ister veya öğrenci360 ekranına ulaşır;
                öğretmen tarafında tüm akış izlenebilir gelişim verisine dönüşür.
              </p>
            </div>
            <div className="dandu-message-stack">
              {messageExamples.map((item) => (
                <MessageExample key={item.text} {...item} />
              ))}
            </div>
          </div>
        </section>

        <section id="platform" className="dandu-section dandu-section-soft">
          <div className="dandu-container">
            <div className="dandu-section-heading dandu-centered">
              <p className="dandu-eyebrow">Platform Modülleri</p>
              <h2>İletişim, gözlem ve gelişim takibi aynı omurgada.</h2>
              <p>
                DANDU, sınıf içi günlük kayıtları, sınav ve değerlendirme
                sonuçlarını veliyle kurulan iletişimden ayırmaz. Her kayıt,
                yapay zekâ desteğiyle çocuğun kendi gelişim hikâyesine bağlanır.
              </p>
            </div>

            <div className="dandu-module-grid">
              {modules.map((module) => (
                <ModuleCard key={module.title} {...module} />
              ))}
            </div>
          </div>
        </section>

        <section id="akis" className="dandu-section dandu-section-dark">
          <div className="dandu-container dandu-split">
            <div>
              <p className="dandu-eyebrow">Nasıl Çalışır?</p>
              <h2>Öğretmenin günlük kayıtları veli iletişimine, veli iletişimi gelişim verisine dönüşür.</h2>
              <p>
                Öğretmen sınıf akışını panelden takip ederken veliler
                WhatsApp’tan iletişim kurar. DANDU iki tarafı aynı çocuk
                bağlamında birleştirir.
              </p>
            </div>
            <div className="dandu-journey-list">
              {workflow.map((item, index) => (
                <div className="dandu-journey-item" key={item.title}>
                  <span>{index + 1}</span>
                  <div>
                    <strong>{item.title}</strong>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="guven" className="dandu-section">
          <div className="dandu-container dandu-trust-band">
            <div>
              <p className="dandu-eyebrow">Güven ve Uygulanabilirlik</p>
              <h2>Çocuğa özel, güvenli ve yarıştırmayan gelişim görünürlüğü.</h2>
            </div>
            <div className="dandu-trust-grid">
              {trustItems.map((item) => (
                <div className="dandu-trust-item" key={item}>
                  <LockRoundedIcon />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="dandu-section dandu-cta-section">
          <div className="dandu-container dandu-cta">
            <div>
              <p className="dandu-eyebrow">DANDU</p>
              <h2>Sınıfınızda veya hazır 2Z demo sınıfında DANDU akışını görün.</h2>
              <p>
                Öğretmen ve veli deneyimini tek akışta görmek için kendi sınıfınızla
                ya da örnek demo sınıfıyla başlayabilirsiniz.
              </p>
            </div>
            <button type="button" onClick={openDemo} className="dandu-btn dandu-btn-primary">
              Demo Başlat
              <ArrowForwardRoundedIcon />
            </button>
          </div>
        </section>
      </main>

      <footer className="dandu-footer">
        <div className="dandu-container dandu-footer-inner">
          <div>
            <strong>DANDU</strong>
            <span>Yeni Nesil Öğretmen-Veli Gelişim Platformu</span>
          </div>
          <div className="dandu-footer-links">
            <a href="/legal/privacy.html">Gizlilik</a>
            <a href="/legal/terms.html">Şartlar</a>
            <a href="/legal/delete-data.html">Veri Silme</a>
          </div>
        </div>
        <LegalFooter />
      </footer>

      {isDemoOpen ? <DemoStartDialog onClose={closeDemo} /> : null}
    </div>
  );
}

function DanduHeader({ onOpenDemo }) {
  return (
    <header className="dandu-nav">
      <div className="dandu-container dandu-nav-inner">
        <a href="/" className="dandu-brand" aria-label="DANDU anasayfa">
          <span className="dandu-brand-mark" aria-hidden="true">
            <img src="/dandu-icon.png" alt="" />
          </span>
          <span>
            <strong>DANDU</strong>
            <small>Öğretmen-Veli Gelişim Platformu</small>
          </span>
        </a>
        <div className="dandu-nav-meta">
          <nav className="dandu-nav-links" aria-label="Ana menü">
            <a href="#kim-icin">Kim İçin?</a>
            <a href="#iletisim">WhatsApp</a>
            <a href="#platform">Platform</a>
            <a href="#akis">Akış</a>
            <a href="mailto:info@kolaykarekod.com">İletişim</a>
          </nav>
          <div className="dandu-nav-actions">
            <button type="button" onClick={onOpenDemo} className="dandu-btn dandu-btn-primary dandu-nav-login">
              Demo Başlat
              <ArrowForwardRoundedIcon />
            </button>
            <a href="/admin" className="dandu-btn dandu-btn-secondary dandu-nav-login">
              <DashboardCustomizeRoundedIcon />
              Panel Girişi
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}

function AudienceCard({ title, desc, icon }) {
  return (
    <article className="dandu-audience-card">
      <span aria-hidden="true">{icon}</span>
      <h3>{title}</h3>
      <p>{desc}</p>
    </article>
  );
}

function ModuleCard({ title, desc, icon }) {
  return (
    <article className="dandu-module-card">
      <div className="dandu-module-icon" aria-hidden="true">
        {icon}
      </div>
      <h3>{title}</h3>
      <p>{desc}</p>
    </article>
  );
}

function MessageExample({ from, text, reply }) {
  return (
    <article className="dandu-message-card">
      <div className="dandu-message-label">
        <MarkUnreadChatAltRoundedIcon />
        <span>{from}</span>
      </div>
      <p className="dandu-message-question">{text}</p>
      <p className="dandu-message-reply">{reply}</p>
    </article>
  );
}

function MiniMetric({ label, value }) {
  return (
    <div className="dandu-mini-metric">
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

function DemoStartDialog({ onClose }) {
  const steps = ["Öğretmen", "Sınıf", "Öğrenci ve Veli", "Önizleme"];
  const [step, setStep] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [submittedLeadId, setSubmittedLeadId] = useState(null);
  const [form, setForm] = useState({
    teacherFirstName: "",
    teacherLastName: "",
    teacherPhone: "",
    branch: "Sınıf",
    className: "",
    gradeLevel: "",
    educationYear: "2026-2027",
    students: [
      {
        parentFirstName: "",
        parentLastName: "",
        parentPhone: "",
        studentFirstName: "",
        studentLastName: "",
        studentNo: "",
        studentPhone: ""
      }
    ]
  });

  const updateField = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  const updateStudent = (index, field, value) => {
    setForm((current) => ({
      ...current,
      students: current.students.map((item, itemIndex) => (
        itemIndex === index ? { ...item, [field]: value } : item
      ))
    }));
  };

  const addStudent = () => {
    setForm((current) => ({
      ...current,
      students: [
        ...current.students,
        {
          parentFirstName: "",
          parentLastName: "",
          parentPhone: "",
          studentFirstName: "",
          studentLastName: "",
          studentNo: "",
          studentPhone: ""
        }
      ]
    }));
  };

  const removeStudent = (index) => {
    setForm((current) => ({
      ...current,
      students: current.students.length > 1
        ? current.students.filter((_, itemIndex) => itemIndex !== index)
        : current.students
    }));
  };

  const submitDemo = async () => {
    setSubmitError("");
    const teacherPhone = form.teacherPhone.trim();
    const className = form.className.trim();
    if (!teacherPhone) {
      setSubmitError("Öğretmen telefonu zorunludur.");
      setStep(0);
      return;
    }
    if (!className) {
      setSubmitError("Sınıf adı zorunludur.");
      setStep(1);
      return;
    }

    const payload = {
      source: "homepage",
      teacher: {
        first_name: form.teacherFirstName,
        last_name: form.teacherLastName,
        phone: form.teacherPhone,
        branch: form.branch
      },
      classroom: {
        name: form.className,
        grade_level: form.gradeLevel,
        education_year: form.educationYear
      },
      students: form.students.map((student) => ({
        parent_first_name: student.parentFirstName,
        parent_last_name: student.parentLastName,
        parent_phone: student.parentPhone,
        student_first_name: student.studentFirstName,
        student_last_name: student.studentLastName,
        student_no: student.studentNo,
        student_phone: student.studentPhone
      }))
    };

    setIsSubmitting(true);
    window.sessionStorage.setItem("danduDemoSetupDraft", JSON.stringify(form));
    try {
      const res = await fetch(apiUrl("/demo-leads"), {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      if (!res.ok) {
        let message = "Demo talebi kaydedilemedi. Lütfen tekrar deneyin.";
        try {
          const data = await res.json();
          message = data?.detail || message;
        } catch (_) {
          // keep fallback message
        }
        setSubmitError(message);
        return;
      }
      const data = await res.json();
      setSubmittedLeadId(data?.id || null);
      setIsSubmitted(true);
    } catch (_) {
      setSubmitError("Bağlantı hatası oluştu. Lütfen tekrar deneyin.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="dandu-demo-overlay" role="dialog" aria-modal="true" aria-labelledby="dandu-demo-title">
      <div className="dandu-demo-dialog">
        <button type="button" className="dandu-demo-close" onClick={onClose} aria-label="Demo penceresini kapat">
          x
        </button>
        <p className="dandu-eyebrow">Demo Başlangıcı</p>
        <h2 id="dandu-demo-title">DANDU kurulumunu birkaç kısa adımda hazırlayın.</h2>
        <p>
          Bu form öğretmen, sınıf, öğrenci ve veli bilgilerini tek akışta toplar.
          Şimdilik bilgileri güvenli bir demo taslağı olarak tarayıcıda tutar; backend
          bağlantısı eklendiğinde aynı akış gerçek kurulum isteğine dönüşebilir.
        </p>

        {isSubmitted ? (
          <div className="dandu-demo-success">
            <strong>Demo taslağı hazırlandı.</strong>
            <span>
              Öğretmen, sınıf ve öğrenci-veli bilgileri süper yönetici ekranındaki
              demo talepleri loguna kaydedildi{submittedLeadId ? ` (#${submittedLeadId})` : ""}.
            </span>
            <button type="button" className="dandu-btn dandu-btn-primary" onClick={onClose}>
              Tamam
            </button>
          </div>
        ) : (
          <>
            <div className="dandu-demo-progress" aria-label="Demo kurulum adımları">
              {steps.map((item, index) => (
                <button
                  type="button"
                  key={item}
                  className={index === step ? "is-active" : ""}
                  onClick={() => setStep(index)}
                >
                  <span>{index + 1}</span>
                  {item}
                </button>
              ))}
            </div>

            <div className="dandu-demo-form">
              {submitError ? (
                <div className="dandu-demo-error">
                  {submitError}
                </div>
              ) : null}

              {step === 0 ? (
                <div className="dandu-demo-panel">
                  <FormField label="Öğretmen adı" value={form.teacherFirstName} onChange={(value) => updateField("teacherFirstName", value)} placeholder="Örn. Ayşe" />
                  <FormField label="Öğretmen soyadı" value={form.teacherLastName} onChange={(value) => updateField("teacherLastName", value)} placeholder="Örn. Yılmaz" />
                  <FormField label="Telefon" value={form.teacherPhone} onChange={(value) => updateField("teacherPhone", value)} placeholder="905xxxxxxxxx" inputMode="tel" />
                  <FormField label="Branş" value={form.branch} onChange={(value) => updateField("branch", value)} placeholder="Sınıf, Matematik, Türkçe..." />
                </div>
              ) : null}

              {step === 1 ? (
                <div className="dandu-demo-panel">
                  <FormField label="Sınıf adı" value={form.className} onChange={(value) => updateField("className", value)} placeholder="Örn. 1E" />
                  <FormField label="Kademe / sınıf düzeyi" value={form.gradeLevel} onChange={(value) => updateField("gradeLevel", value)} placeholder="Örn. 1. sınıf" />
                  <FormField label="Eğitim yılı" value={form.educationYear} onChange={(value) => updateField("educationYear", value)} placeholder="2026-2027" />
                  <div className="dandu-demo-note">
                    Sınıf adı, öğretmen ve veli erişimlerinin aynı sınıf altında güvenli şekilde gruplanması için kullanılır.
                  </div>
                </div>
              ) : null}

              {step === 2 ? (
                <div className="dandu-student-list">
                  {form.students.map((student, index) => (
                    <div className="dandu-student-card" key={`student-${index}`}>
                      <div className="dandu-student-card-head">
                        <strong>Öğrenci ve veli {index + 1}</strong>
                        <button type="button" onClick={() => removeStudent(index)} disabled={form.students.length === 1}>
                          Kaldır
                        </button>
                      </div>
                      <div className="dandu-demo-panel">
                        <FormField label="Veli adı" value={student.parentFirstName} onChange={(value) => updateStudent(index, "parentFirstName", value)} placeholder="Veli adı" />
                        <FormField label="Veli soyadı" value={student.parentLastName} onChange={(value) => updateStudent(index, "parentLastName", value)} placeholder="Veli soyadı" />
                        <FormField label="Veli telefon" value={student.parentPhone} onChange={(value) => updateStudent(index, "parentPhone", value)} placeholder="905xxxxxxxxx" inputMode="tel" />
                        <FormField label="Öğrenci adı" value={student.studentFirstName} onChange={(value) => updateStudent(index, "studentFirstName", value)} placeholder="Öğrenci adı" />
                        <FormField label="Öğrenci soyadı" value={student.studentLastName} onChange={(value) => updateStudent(index, "studentLastName", value)} placeholder="Öğrenci soyadı" />
                        <FormField label="Öğrenci no" value={student.studentNo} onChange={(value) => updateStudent(index, "studentNo", value)} placeholder="Opsiyonel" />
                      </div>
                    </div>
                  ))}
                  <button type="button" className="dandu-demo-add" onClick={addStudent}>
                    Öğrenci ve veli ekle
                  </button>
                </div>
              ) : null}

              {step === 3 ? (
                <div className="dandu-demo-summary">
                  <div>
                    <strong>Öğretmen</strong>
                    <span>{[form.teacherFirstName, form.teacherLastName].filter(Boolean).join(" ") || "Henüz girilmedi"}</span>
                    <small>{form.teacherPhone || "Telefon yok"} • {form.branch || "Branş yok"}</small>
                  </div>
                  <div>
                    <strong>Sınıf</strong>
                    <span>{form.className || "Henüz girilmedi"}</span>
                    <small>{form.gradeLevel || "Kademe yok"} • {form.educationYear || "Eğitim yılı yok"}</small>
                  </div>
                  <div>
                    <strong>Öğrenci ve veli</strong>
                    <span>{form.students.length} kayıt</span>
                    <small>Her veli yalnızca kendi çocuğunun gelişim ekranına erişir.</small>
                  </div>
                </div>
              ) : null}
            </div>

            <div className="dandu-demo-actions">
              <button type="button" className="dandu-btn dandu-btn-secondary" onClick={() => setStep((current) => Math.max(0, current - 1))} disabled={step === 0}>
                Geri
              </button>
              {step < steps.length - 1 ? (
                <button type="button" className="dandu-btn dandu-btn-primary" onClick={() => setStep((current) => Math.min(steps.length - 1, current + 1))}>
                  İleri
                  <ArrowForwardRoundedIcon />
                </button>
              ) : (
                <button type="button" className="dandu-btn dandu-btn-primary" onClick={submitDemo} disabled={isSubmitting}>
                  {isSubmitting ? "Kaydediliyor..." : "Demo Talebini Kaydet"}
                  <ArrowForwardRoundedIcon />
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function FormField({ label, value, onChange, placeholder, inputMode }) {
  return (
    <label className="dandu-form-field">
      <span>{label}</span>
      <input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        inputMode={inputMode}
      />
    </label>
  );
}

export default Home;
